<script>
	
    
    import Tabs from "./HelpTabs.svelte";
    import Gosterge from "./HelpGosterge.svelte";
	import Formul from "./HelpFormul.svelte";
	import Deger from "./HelpDeger.svelte";

  // List of tab items with labels, values and assigned components
  let items = [
    { label: "Gösterge Oluşturma",
		 value: 1,
		 component: Gosterge
		},
    { label: "Formül Oluşturma",
		 value: 2,
		 component: Formul
		},
    { label: "Değer Girme",
		 value: 3,
		 component: Deger
		}
  ];
</script>

<Tabs {items} />